import React, { useEffect, useState } from 'react';
import {
  Box, Card, makeStyles,
} from '@material-ui/core';
import { timeStampToStringView } from '../../helpers/convert-to-timestamp';

interface ITaskItemTeacherProps {
  task: any;
}

const useStyles = makeStyles(() => ({
  card: {
    padding: '1em',
    marginBottom: '1em',
    '& h3': {
      margin: '0',
    },
    '& h4': {
      margin: '0',
    },
  },
  shadow: {
    boxShadow: `rgb(0 0 0 / 20%) 0px 10px 10px -4px, 
    rgb(0 0 0 / 14%) 0px 3px 4px 0px, 
    rgb(0 0 0 / 12%) 0px 1px 8px 0px`,
  },
  svg: {
    maxWidth: '2.5em',
    minWidth: '2.5em',
  },
}));

const TaskItemTeacher: React.FC<ITaskItemTeacherProps> = ( props ) => {
  const classes = useStyles();
  const { task } = props;

  const [theTask, setTheTask] = useState<any>();

  useEffect(() => {
    setTheTask( task );
  }, [task]);

  return (
    <Card className={`${classes.card} ${classes.shadow}`}>
      <Box display="flex" justifyContent="space-between">
        <Box>
          <h3>{theTask && theTask.subject.name}</h3>
          <h4>
            {theTask && theTask.title}
            {'  -  '}
            Fecha de entrega
            {': '}
            {timeStampToStringView( theTask && theTask.dateEnd.seconds )}
          </h4>
        </Box>
      </Box>
    </Card>
  );
};

export default TaskItemTeacher;
